import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { AuthenticationService } from '../../../_services/index';
import { GlobalsPaths } from '../../../app.config';
import { UsersService } from '../../../_services/users.service';
import { environment } from 'environments/environment';
import { LanguagesStaticText } from 'app/_services/language.servic';


@Component({
  selector: 'header-app',
  templateUrl: `./header.html`
})

export class HeaderComponent implements OnInit {
  img: string = this.globalsPaths.img;
  isLimitedUser: boolean = false;
  userName: string;
  url: string;
  isAnonymous: boolean = false;

  hasPermissionVehicleCheck: boolean;
  hasPermissionMobileye: boolean;
  hasPermissionDriverBehavior: boolean;
  hasPermissionTimesheet: boolean;
  hasPermissionTrips: boolean;
  public selectedLanguage: string = localStorage.getItem('SelectedLanguage') || "EN";
  public languages: any[] = [];

  defectAppUrl: string = environment.defectAppUrl;
  vehicleUtilisationAppUrl: string = environment.vehicleUtilisationAppUrl;
  constructor(private globalsPaths: GlobalsPaths,
    private router: Router,
    private authenticationService: AuthenticationService,
    private languagesStaticText: LanguagesStaticText,
    private usersService: UsersService) {

  }

  ngOnInit() {

      // Subscribe to translation config observables
      this.languagesStaticText.language_configs$.subscribe((data) => {

        if (data && data.length > 0) {
          this.languages = data
          const selectedLang = localStorage.getItem('SelectedLanguage');
          console.log('Header selectedLang: ', selectedLang);
          if(this.selectedLanguage) {
            this.selectedLanguage = selectedLang;
          } else{
            localStorage.setItem('SelectedLanguage', "EN");
            this.languagesStaticText.handleChangeLanguage("EN");
          }
          
        } else {
          console.log('No language configs fetched')
          this.selectedLanguage = localStorage.getItem('SelectedLanguage') || "EN";
        }
        
      });
      
      
     
      this.router.events.subscribe((event) => {

        if (event instanceof NavigationEnd) {
          //this.title = this.getDeepestTitle(this.router.routerState.snapshot.root);

          this.url = event.url.split("?")[0];
          let substring = "help/vehicle/";
          if (this.url.includes(substring))
            this.isAnonymous = true;

          // Get current logged in user and set perms object to local storage
          if (this.url != '/' && this.url != '/login' && this.url != '/set_password' && this.url != '/forgot-password' && this.url != '/reset_password_key' && this.url != '/unauthorised' && !this.isAnonymous) {
            let _currentUser = JSON.parse(localStorage.getItem('currentUser'));
            // Check if the new object 'user' is in the currentUser localstorage item - this is a new object that has been added
            if (_currentUser !== null && _currentUser.user != undefined) {
              this.isLimitedUser = _currentUser.user.permission.is_limited_user;
              this.userName = _currentUser.user.first_name + ' ' + _currentUser.user.last_name;
            } else {
              console.log('_currentUser.user is undefined - logut');
              this.authenticationService.logout();
            }

          }

        }

    });
  }


  

  public onChangeLanguage(e){
    this.languagesStaticText.handleChangeLanguage(e.value);
    this.selectedLanguage = e.value
  }

  public logout() {
    this.authenticationService.logout();
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/Header/header.component.ts